/**
 * The lobby room's own tiny protocol (backend.md §3.8).
 *
 * `LobbyRoom` is a separate Colyseus room whose state is the list of *public*
 * tables plus a headcount. Private rooms are never published to it, which is
 * why the summary has no `isPrivate` field to get wrong.
 */
import { z } from 'zod';
import { CHAT_LIMITS } from './senas.js';
export const lobbyChatSendSchema = z.object({
    text: z.string().trim().min(1).max(CHAT_LIMITS.maxLength),
});
//# sourceMappingURL=lobby.js.map